export const DASHBOARD_RANGE_OPTIONS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '6m', label: 'Last 6 months' },
  { value: '12m', label: 'Last 12 months' },
  { value: 'all', label: 'From start' },
];

export const DEFAULT_DASHBOARD_RANGE = 'all';

const getExclusiveTomorrow = now => new Date(Date.UTC(
  now.getUTCFullYear(),
  now.getUTCMonth(),
  now.getUTCDate() + 1
));

const subtractUtcDays = (date, days) => {
  const result = new Date(date);
  result.setUTCDate(result.getUTCDate() - days);
  return result;
};

export const getDashboardDateRange = (
  range = DEFAULT_DASHBOARD_RANGE,
  now = new Date()
) => {
  const toDate = getExclusiveTomorrow(now);
  let fromDate;
  let granularity = 'month';

  switch (range) {
    case 'all':
      fromDate = null;
      break;
    case '7d':
      fromDate = subtractUtcDays(toDate, 7);
      granularity = 'day';
      break;
    case '30d':
      fromDate = subtractUtcDays(toDate, 30);
      granularity = 'day';
      break;
    case '90d':
      fromDate = subtractUtcDays(toDate, 90);
      break;
    case '12m':
      fromDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth() - 11,
        1
      ));
      break;
    case '6m':
    default:
      fromDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth() - 5,
        1
      ));
      break;
  }

  return {
    ...(fromDate ? { from: fromDate.toISOString() } : {}),
    to: toDate.toISOString(),
    granularity,
    timezone: 'UTC',
    range,
  };
};

export const formatDashboardUpdatedAt = value => {
  if (!value) return 'Not updated yet';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Not updated yet';

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
